<div edsGrid [ngClass]="{ 'has-edit-button': isEditMode }">
  <ng-container
    *ngIf="isEditMode"
    [brManageContentButton]="document"
    documentTemplateQuery="new-LiteratureBanner-document"
    folderTemplateQuery="new-LiteratureBanner-folder"
    parameter="document"
    [relative]="false"
    root=""
  >
  </ng-container>
</div>

<div *ngIf="document">
  <eds-banner-nav
    [theme]="type ? type : 'dark'"
    edsSpacing="xxl"
    [breadcrumbItems]="showBreadcrumb ? breadcrumbItems : null"
    [isEdsIcon]="true"
    [isImg]="false"
    [title]="content.title"
    [subTitle]="content.subTitle"
    [preTitle]="content.category"
    [navCards]="cards"
  ></eds-banner-nav>
</div>
<!-- If No Document -->
<div *ngIf="!document && isEditMode" class="no-document">
  <div edsGrid class="no-document__component">
    <div class="no-document__overlay">
      Click to configure <strong>Literature banner</strong>
    </div>
  </div>
</div>
